import Vue from 'vue'
import { login, getInfo } from '@/api/user'
import { welcome } from '@/utils/util'
import { registerUser } from '@/utils/registerUser'
import router from '@/router'
import store from '@/store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roleid:'',
    permissions: [],
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLEID: (state, roleid) => {
      state.roleid = roleid
    },
    SET_PERMISSION: (state, permissions) => {
      state.permissions = permissions
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    UPDATE_INFO:  (state, item) => {
      state.info[item.key] = item.value
    },
    CLEAR_INFO: (state) => {
      Object.assign(state, {
        token: '',
        name: '',
        welcome: '',
        avatar: '',
        roleid: '',
        permissions: [],
        info: {}
      })
    }
  },

  actions: {
    // 登录GetUserInfo
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {
          if (res.code != 200) {
            reject(res.msg)
            return
          }
          Vue.ls.set(ACCESS_TOKEN, res.data.token, 7200000)
          commit('SET_TOKEN', res.data.token)
          store.dispatch('GetUserInfo').then(permissions => {
            store.dispatch('GenerateHomeRoutes', permissions).then(() => {
              resolve()
            })
          })
        }).catch(error => {
          reject(error.message)
        })
      })
    },

    RegisterUser ({}, newUser) {
      return new Promise((resolve, reject) => {
        registerUser(newUser).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetUserInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          if(res.code!=200) throw '无权访问'
          var userInfo = res.data
          //
          var userPermission = res.user_permission
          commit('SET_PERMISSION', userPermission)
          commit('SET_INFO', userInfo)
          commit('SET_NAME', { name: userInfo.user_name, welcome: welcome() })
          commit('SET_AVATAR', userInfo.user_avatar)
          commit('SET_ROLEID', userInfo.role_id)
          resolve(userPermission)
        }).catch(error => {
          reject(error)
        })
      })
    },
    Logout ({ commit }, userWantToLogout = false) {
      var query = {}
      const projectId = store.getters.projectId
      commit('CLEAR_INFO')
      store.dispatch('CleanProject')
      store.dispatch('CleanPermissions')
      Vue.ls.remove(ACCESS_TOKEN)
      if (userWantToLogout) { // 主动登出时
        router.replace({ name: 'login', params: { notRedirect: true } })
      } else {
        if (projectId)query.project_id = projectId
        query.to = router.history.current.path
        router.push({ name: 'login', query: query })
      }
    }
  }
}

export default user
